import { render, staticRenderFns } from "./vergence.score.vue?vue&type=template&id=7a0a73b1&scoped=true"
import script from "./vergence.score.vue?vue&type=script&lang=js"
export * from "./vergence.score.vue?vue&type=script&lang=js"
import style0 from "./vergence.score.vue?vue&type=style&index=0&id=7a0a73b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a73b1",
  null
  
)

export default component.exports